/* PAKKS JOURNAL runtime (Shopify). Topic filter and pages are real links (no JS needed). This file:
   1. upgrades the article's FAQ markup (.faq-section / .faq-item / .faq-question / .faq-answer) into the brand accordions
   2. turns .callout boxes into the preview's callout (emoji icon kept, hidden from screen readers), *word* markdown into <em>
   3. "Copy link" (Clipboard API with a fallback), result announced in a status line */
(function () {
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var body = document.querySelector('[data-article-body]');
  if (body) {
    $$('.faq-section', body).forEach(function (sec) {
      var h = sec.querySelector('h2, h3'), wrap = document.createElement('section'), list = document.createElement('div');
      wrap.className = 'jr-faq'; list.className = 'pdp-faq__list';
      if (h) { var nh = document.createElement('h2'); nh.id = 'jr-faq-h'; nh.textContent = h.textContent.trim(); wrap.setAttribute('aria-labelledby', 'jr-faq-h'); wrap.appendChild(nh); }
      $$('.faq-item', sec).forEach(function (it) {
        var q = it.querySelector('.faq-question'), a = it.querySelector('.faq-answer'); if (!q || !a) return;
        var d = document.createElement('details'), s = document.createElement('summary'), p = document.createElement('div');
        d.className = 'pdp-acc pdp-acc--faq'; s.textContent = q.textContent.trim(); p.className = 'pdp-acc__p jr-faq__a'; p.innerHTML = a.innerHTML;
        d.appendChild(s); d.appendChild(p); list.appendChild(d);
      });
      wrap.appendChild(list); sec.parentNode.replaceChild(wrap, sec);
    });
    $$('.callout', body).forEach(function (c) {
      var p = document.createElement('p'), t = c.innerHTML.trim(), m = t.match(/^(\p{Extended_Pictographic}️?)\s*/u);
      p.className = 'jr-callout';
      p.innerHTML = (m ? '<span class="jr-callout__ico" aria-hidden="true">' + m[1] + '</span>' : '') + '<span>' + (m ? t.slice(m[0].length) : t) + '</span>';
      c.parentNode.replaceChild(p, c);
    });
    $$('p, li', body).forEach(function (el) { if (/(^|[\s(—–-])\*[^*\s][^*]*\*(?=[\s.,;:!?)—–-]|$)/.test(el.innerHTML)) el.innerHTML = el.innerHTML.replace(/(^|[\s(—–-])\*([^*\s][^*]*)\*(?=[\s.,;:!?)—–-]|$)/g, '$1<em>$2</em>'); });
  }
  $$('[data-jr-copy]').forEach(function (btn) {
    var out = document.querySelector('[data-jr-copy-status]');
    function say(t) { out.textContent = ''; setTimeout(function () { out.textContent = t; }, 30); }
    function fallback(url) {
      var ta = document.createElement('textarea'); ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); btn.focus(); return ok;
    }
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-jr-copy'), ok = btn.getAttribute('data-ok'), fail = btn.getAttribute('data-fail').replace('{url}', url);
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(function () { say(ok); }, function () { say(fallback(url) ? ok : fail); });
      else say(fallback(url) ? ok : fail);
    });
  });
})();
